import React from "react";
import { ChevronRight } from "lucide-react";

import { Link } from "react-router-dom";

const Breadcrumb = ({ items }) => (
  <div className="inline-flex items-center gap-2 px-2 py-1 rounded-md text-xs bg-[#EDF0F8] text-[#A3A9C2]">
    {items.map((item, index) => (
      <React.Fragment key={index}>
        {item.path ? (
          <Link
            to={item.path}
            className="hover:text-[#007BFF]"
          >
            {item.label}
          </Link>
        ) : (
          <span className="text-[#007BFF] font-medium">
            {item.label}
          </span>
        )}

        {index < items.length - 1 && (
          <ChevronRight className="w-4 h-4" />
        )}
      </React.Fragment>
    ))}
  </div>
);


export default Breadcrumb;